import React, { useEffect, useState } from 'react';
import { Typography, Form, Input, DatePicker, Button, Select, InputNumber, Row, Col } from 'antd';
import SecurityService from '../../services/SecurityService';
import { useAuth } from '../../hooks/useAuth';
import ShareTransferService from '../../services/ShareTransferService';
import SecurityCompanyService from '../../services/SecurityCompanyService';

const { Title, Text } = Typography;
const ShareTransfer = () => {
  const { showNotification } = useAuth();
  const [securities, setSecurities] = useState([]);
  const [securityCompanies, setSecurityCompanies] = useState([]);
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const symbolCode = securities.map(item => item.symbolCode).sort();
  const securityCompanyName = securityCompanies.map(item => item.securityCompanyName).sort();
  const onRequiredTypeChange = ({ symbolCode, securityCompanyName }) => {
    if (symbolCode) {
      let security = securities.find(security => security.symbolCode === symbolCode);
      form.setFieldsValue({
        securityName: security.securityName,
        securityCode: security.securityCode,
        isinCode: security.isinCode,
      
      });
    }
    if (securityCompanyName) {
      let company = securityCompanies.find(company => company.securityCompanyName === securityCompanyName);
      form.setFieldsValue({
        securityCompanyName: company.securityCompanyName,
        amiCode: company.amiCode,
        shareSettlementAccNo: company.shareSettlementAccNo
      });
    }
  };


  useEffect(() => {
    const fetchInitialData = async () => {
      setLoading(true);
  
      try {
        const securitiesPromise = SecurityService.getSecurities();
        const securityCompaniesPromise = SecurityCompanyService.getSecurityCompanyList();
        const [securitiesResponse, securityCompaniesResponse] = await Promise.all([
          securitiesPromise,
          securityCompaniesPromise
        ]);
        if (securitiesResponse.success) {
          setSecurities(securitiesResponse.securityDataList);
        } else {
          showNotification('error', securitiesResponse.message);
        }
        if (securityCompaniesResponse.success) {
          setSecurityCompanies(securityCompaniesResponse.securityCompanyList);
        } else {
          showNotification('error', securityCompaniesResponse.message);
        }
      } catch (error) {
        showNotification('error', error.message || 'An error occurred while fetching data.');
      } finally {
        setLoading(false); 
      }
    };
  
    fetchInitialData();
    
  }, []);
  console.log(securities, securityCompanies)
  const onFinish = async formValues => {
    const payload = {
      tradingAccountNo: formValues.tradingAccountNo,
      symbolCode: formValues.symbolCode,
      securityCode: formValues.securityCode,
      isinCode: formValues.isinCode,
      securityCompanyName: formValues.securityCompanyName,
      amiCode: formValues.amiCode,
      shareSettlementAccNo: formValues.shareSettlementAccNo,
      quantity: formValues.quantity,
      tradeWindow: formValues.tradeWindow.format('YYYYMMDD'),
      transferWindow: formValues.transferWindow.format('YYYYMMDD'),
      settlementWindow: formValues.settlementWindow.format('YYYYMMDD'),
    };

    let response;
    setLoading(true);
    if (formValues.shareTransferType === 'INWARD') {
      response = await ShareTransferService.shareInwardTransfer(payload);
    } else {
      response = await ShareTransferService.shareOutwardTransfer(payload);
    }
    setLoading(false);
    if (response.success) {
      showNotification('success', response.message);
      form.resetFields();
    } else showNotification('error', response.message);
  };
  return (
    <>
      <Title level={4} style={{ marginTop: 0, marginBottom: '2rem' }}>
        Share Transfer
      </Title>
      <Form
        className="block-trade-form"
        onFinish={onFinish}
        form={form}
        labelCol={{
          span: 12,
        }}
        style={{
          padding: '2rem 0',
        }}
        onValuesChange={onRequiredTypeChange}
        // requiredMark={requiredMark}
      >
        <Row gutter={16}>
          <Col xs={24} sm={24} md={12}>
          <Form.Item
              label={'Trading Account No'}
              name={'tradingAccountNo'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={'Share Transfer Type'}
              name={'shareTransferType'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <Select size="middle">
                <Select.Option value="INWARD">INWARD</Select.Option>
                <Select.Option value="OUTWARD">OUTWARD</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="Quantity"
              name={'quantity'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <InputNumber
                style={{ width: '100%' }}
                min={1}
                formatter={value => Number(value).toLocaleString('en-US')}
                parser={value => Number(value.toString().split(',').join(''))}
              />
            </Form.Item>

           
            <Form.Item
              label="Security Company Name"
              name={'securityCompanyName'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <Select size="middle">
                {securityCompanyName.map((item, index) => (
                  <Select.Option key={index} value={item}>
                    {item}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="AMI Code"
              name={'amiCode'}
              // rules={[
              //   {
              //     required: true,
              //     message: 'Please do not leave blank',
              //   },
              // ]}
              initialValue={''}
            >
              <Input size="middle" disabled />
            </Form.Item>
            <Form.Item
              label="Share Settlement Acc No"
              name={'shareSettlementAccNo'}
              // rules={[
              //   {
              //     required: true,
              //     message: 'Please do not leave blank',
              //   },
              // ]}
              initialValue={''}
            >
              <Input size="middle" disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
          <Form.Item
              label="Symbol Code"
              name={'symbolCode'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <Select size="middle">
                {symbolCode.map((item, index) => (
                  <Select.Option key={index} value={item}>
                    {item}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Security Code"
              name={'securityCode'}
              // rules={[
              //   {
              //     required: true,
              //     message: 'Please do not leave blank',
              //   },
              // ]}
              initialValue={''}
            >
              <Input size="middle" disabled />
            </Form.Item>
            <Form.Item
              label="Security Name"
              name={'securityName'}
              // rules={[
              //   {
              //     required: true,
              //     message: 'Please do not leave blank',
              //   },
              // ]}
              initialValue={''}
            >
              <Input size="middle" disabled />
            </Form.Item>
            <Form.Item
              label="ISIN Code"
              name={'isinCode'}
              // rules={[
              //   {
              //     required: true,
              //     message: 'Please do not leave blank',
              //   },
              // ]}
              initialValue={''}
            >
              <Input size="middle" disabled />
            </Form.Item>
            <Form.Item
              label={'Trade Window'}
              name={'tradeWindow'}
              rules={[
                {
                  required: true,
                  message: 'Please select the date',
                },
              ]}
            >
              <DatePicker className="date-picker" />
            </Form.Item>
            <Form.Item
              label={'Transfer Window'}
              name={'transferWindow'}
              rules={[
                {
                  required: true,
                  message: 'Please select the date',
                },
              ]}
            >
              <DatePicker className="date-picker" />
            </Form.Item>
            <Form.Item
              label={'Settlement Date'}
              name={'settlementWindow'}
              rules={[
                {
                  required: true,
                  message: 'Please select the date',
                },
              ]}
            >
              <DatePicker className="date-picker" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            key={'submit'}
            style={{ float: 'right' }}
            loading={loading}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default ShareTransfer;
